import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { Formik } from 'formik'
import { useAsyncFn } from 'react-use'

import { Box } from 'components/Box'
import { Button } from 'components/Button'
import { Heading, Text } from 'components/Text'
import { themes } from 'styles'
import { TextInput } from 'components/Inputs'
import { StreamLogo } from 'components'

const Form = styled(Box).attrs({
  as: 'form',
})`
  & > * + * {
    margin-top: 0.5rem;
  }
`

const FormFooter = styled(Box)`
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`

const initialValues = {
  name: '',
  email: '',
  twitter: '',
}

export const UserCapture = ({ backgroundColor, eventName }) => {
  const [{ loading, value }, onSubmit] = useAsyncFn(async (values) => {
    const response = await fetch(
      'https://cymjbefbpl.execute-api.us-east-1.amazonaws.com/prod/user-capture',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...values,
          event: eventName,
        }),
      }
    )
    const result = await response.json()
    return result
  })

  const done = value?.data?.success
  if (done) {
    return (
      <Box
        marginY={6}
        paddingY={[6, 6, 7]}
        paddingX={[5, 6, 7]}
        backgroundColor={backgroundColor}
        borderRadius={['unset', 'unset', 3]}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <StreamLogo size={1} />
        <Heading marginY={4} fontWeight="800">
          Thank you!
        </Heading>
      </Box>
    )
  }

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {(formik) => (
        <ThemeProvider theme={themes.light}>
          <Box
            marginY={6}
            paddingY={[6, 6, 7]}
            paddingX={[5, 6, 7]}
            backgroundColor={backgroundColor}
            borderRadius={['unset', 'unset', 3]}
          >
            <Heading fontWeight="800">
              <span aria-label="Congratulations" role="img">
                🎉
              </span>{' '}
              Congratulations
            </Heading>
            <Text
              style={{ maxWidth: 320 }}
              color="altText"
              fontSize={[2, 3, 4]}
              lineHeight={[4, 5, 6]}
              marginY={4}
              as="h5"
            >
              This codelab is complete. Fill out the form to let us know you
              made it, and be in with the chance of winning prizes!
            </Text>
            <Form onSubmit={formik.handleSubmit}>
              <TextInput
                name="name"
                label="Name"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.name}
              />
              <TextInput
                name="email"
                label="Email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.email}
                type="email"
              />
              <TextInput
                name="twitter"
                label="Twitter (optional)"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.twitter}
              />
              <FormFooter>
                <Button
                  loading={loading}
                  disabled={loading || !formik.dirty || !formik.isValid}
                  label="Submit"
                  type="submit"
                  backgroundColor="black"
                />
              </FormFooter>
            </Form>
          </Box>
        </ThemeProvider>
      )}
    </Formik>
  )
}

UserCapture.defaultProps = {
  backgroundColor: 'white',
}
